import Branding from "./Configurator";
import Integration from "./Integration";
import Health from "./Health";
import NotesTicket from "./NotesTicket";
import LocationUsers from "./LocationUsers";
import DataMaping from "./DataMaping";
// import Billing from "./billing";
import ChatQuestion from "./ChatQuestion";

const routes = [
 
  {
    type: "collapse",
    key: "branding",
    route: "/branding",
    component: <Branding />,
  },
  {
    type: "collapse",
    key: "integration",
    route: "/integration",
    component: <Integration />,
  },
  {
    type: "collapse",
    key: "notes",
    route: "/notes",
    component: <NotesTicket />,
  },
  {
    type: "collapse",
    key: "health",
    route: "/health",
    component: <Health />,
  },
  {
    type: "collapse",
    key: "locationusers",
    route: "/locationusers",
    component: <LocationUsers />,
  },
  {
    type: "collapse",
    key: "mapping",
    route: "/mapping",
    component: <DataMaping />,
  },
  // {
  //   type: "collapse",
  //   key: "wallet",
  //   route: "/wallet",
  //   component: <Billing />,
  // },
];

export default routes;
